import { useTranslation } from "react-i18next";
import { Download, FileSpreadsheet, Gavel } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { exportPenaltyReport } from "../../api/penaltyReport";

// عنوان تقرير العقوبات + تصدير Excel و PDF.
export const PenaltyReportHeader = ({ filters }) => {
  const { t, i18n } = useTranslation();
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <p className="label-xs flex items-center gap-2">
        <Gavel className="h-4 w-4 text-primary" /> {t("penalty.report.title")}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        <NeuButton data-testid="penalty-export-excel" className="flex items-center gap-2 px-3 py-2 text-xs"
                   onClick={() => exportPenaltyReport("xlsx", i18n.language, filters)}>
          <FileSpreadsheet className="h-4 w-4" /> Excel
        </NeuButton>
        <NeuButton data-testid="penalty-export-pdf" className="flex items-center gap-2 px-3 py-2 text-xs"
                   onClick={() => exportPenaltyReport("pdf", i18n.language, filters)}>
          <Download className="h-4 w-4" /> PDF
        </NeuButton>
      </div>
    </div>
  );
};
